module.exports = __webpack_public_path__ + "img/infograph_1.0f84d56c.png";